import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import Filter from "../FilterData/Filter";
import { FilterMaterial } from "../FilterData/FilterData";
import { useNavigate } from "react-router-dom";
import { getmaterial } from "../../API_Service/API_Links";
import axios from "axios";
import SnackBar from "../SnackBar";

export default function StoreFactoryProject() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const navigate = useNavigate();
  const [data, setdata] = useState([]);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState();
  const [color, setColor] = useState();

  const [materialCodeSearch, setmaterialCodeSearch] = useState("");
  const [materialNameSearch, setmaterialNameSearch] = useState("");

  useEffect(() => {
    axios({
      method: "GET",
      url: getmaterial,
    })
      .then((res) => {
        if (res.data.error) {
          setMessage(res.data.message);
          setOpen(true);
          setStatus(false);
          setColor(false);
        } else {
          setMessage(res.data.message);
          setdata(res.data.data);
          setOpen(true);
          setStatus(true);
          setColor(true);
        }
      })
      .catch((err) => {
        alert("Oops something went wrong " + err);
      });
  }, []);

  const statusMapping = {
    1: "In-Progress",
    2: "Purchase Pending",
    3: "Finance Pending",
    4: "Finance Approved",
    5: "Raw Material Available",
    6: "Assigned To Employee",
    7: "Completed",
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenEdit = (i) => {
    navigate("viewstore", { state: { id: i.ProjectId } });
  };

  const keys = Object.keys(data[0] || {}).filter((key) => key !== "MaterialId");

  return (
    <Box p={2}>
      <Box boxShadow={4} bgcolor="#EDF4F4" className="cardBoxshadow">
        <SnackBar
          open={open}
          message={message}
          setOpen={setOpen}
          status={status}
          color={color}
        />
        <Container>
          <Box mt={2} py={4}>
            <Grid container>
              <TableContainer sx={{ border: "1px solid silver" }}>
                <Table>
                  <TableHead
                    sx={{ whiteSpace: "nowrap", bgcolor: "success.main" }}
                  >
                    <TableRow>
                      {keys.map((key) => (
                        <TableCell
                          sx={{
                            color: "white",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                          key={key}
                        >
                          <Box
                            sx={{ display: "flex", justifyContent: "center" }}
                          >
                            <Box
                              sx={{ my: "auto", textTransform: "uppercase" }}
                            >
                              {key.split(/(?=[A-Z])/).join(" ")}
                            </Box>
                            {key === "MaterialCode" && (
                              <Box>
                                <Filter
                                  search={materialCodeSearch}
                                  setSearch={setmaterialCodeSearch}
                                  setPage={setPage}
                                />
                              </Box>
                            )}
                            {key === "MaterialName" && (
                              <Box>
                                <Filter
                                  search={materialNameSearch}
                                  setSearch={setmaterialNameSearch}
                                  setPage={setPage}
                                />
                              </Box>
                            )}
                          </Box>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {FilterMaterial(
                      data,
                      materialNameSearch,
                      materialCodeSearch
                    )
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row, index) => (
                        <TableRow key={index}>
                          {keys.map((key) => (
                            <TableCell align="center" key={key}>
                              {row[key]}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={
                  FilterMaterial(data, materialCodeSearch, materialNameSearch)
                    .length
                }
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Grid>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}

// const StoredSelectedTeam = () => {
//     // This is to display Team and Staff
//     const newObject = {
//         team: teamName,
//         staff: staffName,
//         StartDate: ProjectStart,
//         EndDate: ProjectEnd
//     };
//     setTeamMemberStaffPairs([...teamMemberStaffPairs, newObject]);
//     // This is to pass them to API
//     const convertedObject = {
//         EmployeeId: teamMember,
//         DepartmentId: staffMember,
//         StartDate: ProjectStart,
//         EndDate: ProjectEnd
//     }
//     setTeamSelectionAPI([...teamSelectionAPI, convertedObject]);
//     setTeamMember([]);
//     setStaffMember([]);
//     setProjectEnd('');
//     setProjectStart('');
//     setInput(true);
// }

{
  /* <Grid
    item
    lg={12}
    sm={12}
    xl={12}
    xs={12}
    md={12}
    sx={{ py: 1 }}
    display='flex'
    justifyContent='center'
>
    <Box sx={{ textAlign: "center" }}>
        {
            teamMemberStaffPairs.length !== 0 &&
            <>
                <Typography variant='h6' fontWeight={600}>Selected Team</Typography>
                {
                    teamMemberStaffPairs.map((i) => {
                        return (
                            <Box textAlign='left'>
                                <Typography variant='subtitle2'>{i.team} - {i.staff} : {i.StartDate} - {i.EndDate}</Typography>
                            </Box>

                        )
                    })
                }
            </>
        }
    </Box>
</Grid> */
}

// const [teamMemberStaffPairs, setTeamMemberStaffPairs] = useState([]);
// const [teamSelectionAPI, setTeamSelectionAPI] = useState([]);

// const [teamName, setTeamName] = useState([]);
// const [staffName, setStaffName] = useState([]);
// const [currentTeam, setCurrentTeam] = useState('');

{
  /* <Grid
    item
    lg={3}
    sm={2}
    xl={3}
    xs={2}
    md={3}
    sx={{ py: 2 }}
>
    <Button onClick={StoredSelectedTeam} variant='contained' fullWidth>+ Add</Button>
</Grid> */
}
